import { CUSTOM_WORKFLOW_TYPE_LABEL } from '@aline/common';
import type { LucideIcon } from 'lucide-react';
import { FilePen, LayoutTemplate } from 'lucide-react';

export type WorkflowTypeSource = {
  id: string;
  name: string;
} | null;

export function getWorkflowTypeLabel(sourceWorkflow: WorkflowTypeSource): string {
  if (!sourceWorkflow) return CUSTOM_WORKFLOW_TYPE_LABEL;
  return sourceWorkflow.name.trim() || 'Untitled Workflow';
}

export function getWorkflowTypeIcon(sourceWorkflow: WorkflowTypeSource): LucideIcon {
  return sourceWorkflow ? LayoutTemplate : FilePen;
}

export type WorkflowTypeFilterOption =
  | { __typename: 'CustomWorkflowType'; id: string; label: string }
  | { __typename: 'WorkflowTypeOption'; id: string; label: string };

export function getIsCustomWorkflowTypeOption(
  option: WorkflowTypeFilterOption
): option is { __typename: 'CustomWorkflowType'; id: string; label: string } {
  return option.__typename === 'CustomWorkflowType';
}
